import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;
